import React from 'react'

export interface ShareWithSupplierCTAProps {
  reviewAuthorName: string
  isRecipientAnonymous: boolean
  setBody: React.Dispatch<React.SetStateAction<string>>
}

export const ShareWithSupplierCTA: React.FC<ShareWithSupplierCTAProps> = ({ reviewAuthorName, isRecipientAnonymous, setBody }) => {
  const salutation = isRecipientAnonymous ? 'there' : reviewAuthorName.split(' ')[0]
  const message = `Hi ${salutation}, I'd like to loop in the supplier to help get this issue resolved, but I can't because the review wasn't shared with them. Can you edit your review and select "Make my review visible to the supplier" under Privacy Settings, please? Then I can start a new conversation between the three of us. Thank you.`

  const appendMessage = (): void => {
    setBody((prev) => {
      if (prev.includes(message)) return prev
      return prev.length > 0 ? `${prev}\n\n${message}` : message
    })
  }

  return (
    <div className='inbox-share-with-supplier-cta'>
      <i className='fa-solid fa-circle-info' />
      <div>
        <strong>Note: </strong>
        When submitting their feedback, the review writer opted not to share it with the supplier.
        As a result, you can only message the review writer directly.
        Click <a className='inbox-share-with-supplier-cta-click-here' onClick={appendMessage}>here</a> to draft a message asking them to change that selection.
      </div>
    </div>
  )
}
